export default __webpack_public_path__ + "static/media/vertical-line.e6e27df6.svg";